import { CSSProperties } from 'react';
import * as STYLE from '../../UIConstants';

export const pageContainerStyle: CSSProperties = {
    display: STYLE.CONSTANTS.DISPLAY.FLEX,
    flexDirection: STYLE.CONSTANTS.FLEX_DIRECTION.COLUMN, 
    height: '100%',
    color: STYLE.CONSTANTS.COLORS.DARK_GREY,
    fontWeight: 500,
    fontSize: STYLE.CONSTANTS.FONT_SIZE.LARGE,
    flexGrow: 1
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Layout/PageContainer.ts